export default "__VITE_ASSET__D4thV$um__"